import { Box } from "@mui/material"
import { useStyles } from "./styles"
import { CustomeDrawerProps } from "./types"

const CustomeDrawer = ({ open, children, drawerProps }: CustomeDrawerProps) => {
    const styles = useStyles()
    if (!open) return <></>
    return (
        <Box {...drawerProps} sx={[styles.drawer, (drawerProps?.sx ?? {} as any)]}>
            <Box sx={styles.children}>
                {children}
            </Box>
        </Box>
    )
}

export { CustomeDrawer }